export default "__VITE_ASSET__cch$uME8__"